const deviceSizes = {
  xs: '480px',
  sm: '576px',
  md: '767px',
  lg: '992px',
  xl: '1200px',
  xxl: '1600px',
} as const;

export default deviceSizes;
